export default __webpack_public_path__ + "static/hkgrotesk-mediumlegacy-webfont-a38481f9fb66b78a1041dcb7c35bbfa1.woff2";